// components/common/CookieConsent.tsx
// ---------------------------------------------------------------------------
// Inline cookie-consent notice. Renders as a single line of text with an
// "OK" button, designed to sit below the landing card. Not fixed-position;
// the parent controls placement. Persists acceptance in localStorage.
// ---------------------------------------------------------------------------

import { alpha, Box, Button, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

const STORAGE_KEY = "athena_cookie_consent";

export default function CookieConsent() {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        opacity: visible ? 1 : 0,
        transition: "opacity 0.4s ease",
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: alpha(theme.palette.common.white, 0.5), fontSize: "0.72rem" }}
      >
        This site uses cookies to ensure the best experience.
      </Typography>
      <Button
        size="small"
        onClick={handleAccept}
        sx={{
          minWidth: 0,
          px: 1,
          py: 0,
          fontSize: "0.7rem",
          fontWeight: 600,
          textTransform: "none",
          color: alpha(theme.palette.common.white, 0.55),
          "&:hover": { color: alpha(theme.palette.common.white, 0.85) },
        }}
      >
        OK
      </Button>
    </Box>
  );
}
